import React, { useEffect, useState, useCallback } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Checkbox, Input, Select } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import Confirmation from '../../components/Confirmation/Confirmation'
import { createPeriodNutrition, getPeriodNutritionFiles, updatePeriodNutrition } from '../../actions/directoryCanteen'
import { api } from '../../App'
import styles from './styles.module.scss'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  sort: Yup.number().required('обязательное поле').typeError('Пожалуйста, введите число').nullable().max(999999999, 'Должно быть не более 9 символов'),
  xp_eat_group: Yup.string().required('обязательное поле'),
})

export default function PeriodNutritionModal({ data, closeModal, width, height, addMode }) {
  const dispatch = useDispatch()
  const { groupNutritionList, files } = useSelector(state => state.directoryCanteen)

  const [image, setImage] = useState(null)
  const [confirmation, setConfirmation] = useState(false)

  const isOpen = !!data

  useEffect(() => {
    if (!files) return
    fetchPhoto(files[0]?.file_name, data?.xp_key)
  }, [files])

  useEffect(() => {
    data?.xp_key && dispatch(getPeriodNutritionFiles(data.xp_key))
  }, [data])

  const handleClose = useCallback(() => {
    setConfirmation(false)
    setImage(null)
    closeModal()
  }, [closeModal])

  const acceptConfirmation = useCallback(() => {
    handleClose()
  }, [handleClose])

  const rejectConfirmation = useCallback(() => {
    setConfirmation(false)
  }, [])

  const handleCreate = async (values) => {
    dispatch(createPeriodNutrition(values, image))
    handleClose()
  }

  const handleUpdate = async ({ xp_key, ...values }) => {
    dispatch(updatePeriodNutrition(xp_key, values, image))
    handleClose()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const handlePick = () => {
    document.getElementById('filePicker').click()
  }

  const handleChangeFile = (e) => {
    setImage(Object.values(e.target.files)[0])
  }

  const fetchPhoto = async (file_name, id) => {
    const { data } = id && await api.get(`/xp_eat_period/file/${id}/${file_name}`, { responseType: 'blob' })
    setImage(data)
  }

  return (
    <>
      <Modal
        open={isOpen}
        onClose={handleClose}
        classNames={{ modal: styles.modal }}
        showCloseIcon={false}
        center
      >
        <div className={styles.modalMain}>
          <div className={styles.tabWrapper}>
            <div className={styles.inputsRow}>
              <Input
                label='Название'
                name='name'
                value={values.name}
                error={error('name')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
              <div style={{ padding: '15px' }}></div>
              <Select
                label='Группа питания'
                value={values.xp_eat_group}
                error={error('xp_eat_group')}
                onChange={handleChange}
                name='xp_eat_group'
              >
                <option value=''>Выберите группу</option>
                {groupNutritionList?.map(({ name, xp_key }) => (
                  <option key={xp_key} value={xp_key}>{name}</option>
                ))}
              </Select>
            </div>
            <div className={styles.inputsRow}>
              <Input
                label='Сортировка'
                name='sort'
                value={values.sort}
                error={error('sort')}
                onChange={handleChange}
                style={{ width: '300px' }}
              />
              <div style={{ padding: '15px' }}></div>
              <Input type='time' label='Начало' value={values.start} name='start' onChange={handleChange} />
              <Input type='time' label='Окончание' value={values.stop > values.start ? values.stop : values.start} name='stop' onChange={handleChange} />
            </div>
            <Checkbox
              label='Отображать калории'
              checked={values.kkalvisible}
              value={values.kkalvisible}
              error={error('kkalvisible')}
              onChange={handleChange}
              name='kkalvisible'
              style={{ margin: '15px' }}
            />
            <div className={styles.buttonsWrap}>
              <div className={styles.buttons}>
                <button type="button" className={styles.uploadBtn} onClick={handlePick}>
                  {image ? 'Изменить фото' : 'Загрузить фото'}
                </button>
                <input
                  className={styles.hidden}
                  type='file'
                  onChange={handleChangeFile}
                  accept="image/*"
                  id='filePicker'
                />
              </div>
            </div>
            <br />
            {!!image && (
              <img
                src={URL.createObjectURL(image)}
                alt="preview"
                height={350}
                width={450}
              />
            )}
          </div>
        </div>
        <ModalFooter handleSubmit={handleSubmit} closeModal={handleClose} />
      </Modal>

      {confirmation && (
        <Confirmation
          title="Есть несохраненные данные. Уверены что хотите выйти?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </>
  )
}
